const strings = {
    systemName: "VAID: Indexing View Designs in Visual Analytics System",
}

export default strings;
